import {baseUrl} from "../../config";
import Box from "@mui/material/Box";
import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";

function VerificationCaseView ({item, imgWidth, handleClose, open}) {
    const borderWidth=10
    return (
        <Dialog onClose={handleClose} open={open}>

            <Box sx={{
                border: borderWidth, borderColor: 'white',
            }} onClick={(event) => handleClose()}>
                <img
                    src={`${baseUrl}/img/${item.fileName}`}
                    alt={item.imagePath}
                    height={imgWidth}
                    width={imgWidth}
                    onClick={(event) => handleClose()}
                    loading="lazy"
                />
                <Typography style={{ fontSize: 14, fontStyle: 'italic'}} variant='string' component="div">
                    {`${item.age}; ${item.sex? "Жен.": "Муж."}; ${item.location}; ${item.beginning}`}
                </Typography>
                {!!item.boundaries && item.boundaries.length > 0 ?
                    item.boundaries.map((boundary, index) =>
                        <div key={index}
                             style={{
                                 position: 'absolute',
                                 zIndex: 2,
                                 left: imgWidth * boundary.leftX+borderWidth,
                                 top: imgWidth * boundary.topY+borderWidth
                             }}>
                            <Box
                                sx={{
                                    width: imgWidth * (boundary.rightX - boundary.leftX),
                                    height: imgWidth * (boundary.bottomY - boundary.topY),
                                    border: 1, borderColor: 'black',
                                }}
                                onClick={(event) => handleClose()}
                            />
                        </div>)
                    : null
                }
            </Box>
        </Dialog>
    )
}

export default VerificationCaseView